import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'storage'
})
export class StoragePipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    let v: number | null = null;

    if (typeof value === 'string') {
      v = parseInt(<string>value, 10);
    } else if (value === null || value === undefined) {
      v = 0;
    } else {
      v = value;
    }

    if (v !== null && v > 0) {
      return `${value} GB`;
    }

    return '0 GB';
  }
}
